// extracted by mini-css-extract-plugin
export default {"dropdownTitle":"styles_dropdownTitle__3xUF6"};